/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseEntityDto, OnlineStatusEnum, TenantDto, UserRole } from '@fleet-beat/core';

export interface UserDto extends BaseEntityDto {
  id?: string;
  avatarUrl?: string;
  role?: UserRole;
  companyId?: string;
  tenantId?: string;
  tenant?: TenantDto;
  password?: string;
  confirmPassword?: string;
  email?: string;
  description?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phone?: string;
  onlineStatus?: OnlineStatusEnum;
  driverStatus?: any;
  telegramNotificationsEnabled?: boolean;
  telegramNotificationsCompanyId?: string;
}
